export type Role = "owner" | "admin" | "member" | "viewer";
export type Permission =
  | "finance:read"
  | "transaction:write"
  | "catalog:write"
  | "member:manage"
  | "audit:read"
  | "workspace:settings"
  | "workspace:delete";

/** Cópia da matriz do backend (apps/api/src/auth/permissions.ts). A API continua sendo a barreira real. */
const MATRIX: Record<Role, Permission[]> = {
  owner: [
    "finance:read",
    "transaction:write",
    "catalog:write",
    "member:manage",
    "audit:read",
    "workspace:settings",
    "workspace:delete",
  ],
  admin: [
    "finance:read",
    "transaction:write",
    "catalog:write",
    "member:manage",
    "audit:read",
    "workspace:settings",
  ],
  member: ["finance:read", "transaction:write"],
  viewer: ["finance:read"],
};

export function can(role: Role | undefined, permission: Permission): boolean {
  return role ? MATRIX[role].includes(permission) : false;
}

export const ROLE_LABEL: Record<Role, string> = {
  owner: "Proprietário",
  admin: "Administrador",
  member: "Membro",
  viewer: "Leitor",
};
